module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sectiontop"
  }, [_vm._v("When I was in my infancy"), _c('br'), _vm._v("\n  The Ferris wheel appealed to me"), _c('br'), _vm._v("\n  And fate has managed to arrange"), _c('br'), _vm._v("\n  That fifty years have seen no change"), _c('br'), _vm._v("\n  But never have I once denied"), _c('br'), _vm._v("\n  I’m mighty grateful for the ride"), _c('br'), _vm._v("\n  And my track record will evince"), _c('br'), _vm._v("\n  I’ve gone in circles ever since.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('i', [_vm._v("Monroe D. Underwood")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cdb2401e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/05_dedicated1.vue
// module id = 66
// module chunks = 0